<template>
  <div class="header">
    <slot />
  </div>
</template>

<script>

export default {
  name: "PageHeader",
}

</script>
